// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file supervisor/v1/environmentopts.proto (package supervisor.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AttachTerminalRequest, AttachTerminalResponse, CancelExecRequest, CancelExecResponse, CloseTerminalRequest, CloseTerminalResponse, CreateTerminalRequest, CreateTerminalResponse, ExecRequest, ExecResponse, FindRequest, FindResponse, GetDefaultBranchRequest, GetDefaultBranchResponse, GetFileDiffContentRequest, GetFileDiffContentResponse, GetGitDiffFilesRequest, GetGitDiffFilesResponse, GetGitDiffRequest, GetGitDiffResponse, GetGitStatusRequest, GetGitStatusResponse, ListTerminalsRequest, ListTerminalsResponse, ReadFileRequest, ReadFileResponse, ReadTerminalRequest, ReadTerminalResponse, ResizeTerminalRequest, ResizeTerminalResponse, WriteFileRequest, WriteFileResponse, WriteTerminalRequest, WriteTerminalResponse } from "./environmentopts_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service supervisor.v1.EnvironmentOpsService
 */
export const EnvironmentOpsService = {
  typeName: "supervisor.v1.EnvironmentOpsService",
  methods: {
    /**
     * @generated from rpc supervisor.v1.EnvironmentOpsService.GetGitStatus
     */
    getGitStatus: {
      name: "GetGitStatus",
      I: GetGitStatusRequest,
      O: GetGitStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc supervisor.v1.EnvironmentOpsService.GetGitDiff
     */
    getGitDiff: {
      name: "GetGitDiff",
      I: GetGitDiffRequest,
      O: GetGitDiffResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetFileDiffContent returns the original and new file content for client-side diffing.
     * This allows the frontend to compute diffs without relying on pre-parsed hunks.
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.GetFileDiffContent
     */
    getFileDiffContent: {
      name: "GetFileDiffContent",
      I: GetFileDiffContentRequest,
      O: GetFileDiffContentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetGitDiffFiles returns the list of files that differ between a base ref and the
     * current working tree. Use this to discover which files to request diffs for via
     * GetGitDiff or GetFileDiffContent.
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.GetGitDiffFiles
     */
    getGitDiffFiles: {
      name: "GetGitDiffFiles",
      I: GetGitDiffFilesRequest,
      O: GetGitDiffFilesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetDefaultBranch returns the name of the default branch (e.g. "main").
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.GetDefaultBranch
     */
    getDefaultBranch: {
      name: "GetDefaultBranch",
      I: GetDefaultBranchRequest,
      O: GetDefaultBranchResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Find searches for files and directories matching the given criteria
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.Find
     */
    find: {
      name: "Find",
      I: FindRequest,
      O: FindResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ReadFile reads file content or lists directory entries
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.ReadFile
     */
    readFile: {
      name: "ReadFile",
      I: ReadFileRequest,
      O: ReadFileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * WriteFile writes content to a file
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.WriteFile
     */
    writeFile: {
      name: "WriteFile",
      I: WriteFileRequest,
      O: WriteFileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CreateTerminal creates a new terminal session
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.CreateTerminal
     */
    createTerminal: {
      name: "CreateTerminal",
      I: CreateTerminalRequest,
      O: CreateTerminalResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ReadTerminal streams terminal output to the client.
     * Multiple clients can read from the same terminal concurrently.
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.ReadTerminal
     */
    readTerminal: {
      name: "ReadTerminal",
      I: ReadTerminalRequest,
      O: ReadTerminalResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * WriteTerminal sends input to a terminal
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.WriteTerminal
     */
    writeTerminal: {
      name: "WriteTerminal",
      I: WriteTerminalRequest,
      O: WriteTerminalResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ResizeTerminal updates terminal dimensions
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.ResizeTerminal
     */
    resizeTerminal: {
      name: "ResizeTerminal",
      I: ResizeTerminalRequest,
      O: ResizeTerminalResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CloseTerminal destroys a terminal session
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.CloseTerminal
     */
    closeTerminal: {
      name: "CloseTerminal",
      I: CloseTerminalRequest,
      O: CloseTerminalResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ListTerminals returns all active terminal sessions
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.ListTerminals
     */
    listTerminals: {
      name: "ListTerminals",
      I: ListTerminalsRequest,
      O: ListTerminalsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * AttachTerminal streams terminal buffer state to the client.
     * The first message is always a TerminalSnapshot containing the full buffer.
     * Subsequent messages are TerminalDiffs with incremental updates.
     * If the client detects a version gap, it should re-attach to get a fresh snapshot.
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.AttachTerminal
     */
    attachTerminal: {
      name: "AttachTerminal",
      I: AttachTerminalRequest,
      O: AttachTerminalResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Exec executes a command in the environment.
     * - Idempotent: same operation_id returns cached result if completed
     * - Durable: survives caller disconnection, results stored on filesystem
     * - Blocking: waits for completion
     * - Context cancellation is treated as transient (operation continues)
     * - Use CancelExec for explicit user cancellation
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.Exec
     */
    exec: {
      name: "Exec",
      I: ExecRequest,
      O: ExecResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CancelExec explicitly cancels an operation (user intent to stop)
     * Fire-and-forget: no error if operation not found or already completed
     *
     * @generated from rpc supervisor.v1.EnvironmentOpsService.CancelExec
     */
    cancelExec: {
      name: "CancelExec",
      I: CancelExecRequest,
      O: CancelExecResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

